module.exports = __webpack_public_path__ + "media/images/map/green-promocode-1ab6d0956823e1ad3cebaa31531543fa.svg";